'use strict';

import { Injectable, Inject } from 'ng-metadata/core';
import {getVid} from "../appConfig/appConfigForward";
import {MappingTablesCache} from "../mappingTablesCache/mappingTablesCache.service";
import { WindowInfoUtils } from '../nddUtils/windowInfoUtils.service';
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";
import {STATE_NAMES} from "../primoExplore/primoExploreStates.module";

const isEqual = require('lodash/isEqual');

@Injectable()
export class ReportProblemService{

    public ACTIVATE_WIDGET: string = "Activate widget";
	public NUM_OF_CATEGORIES: string = "Number of categories";
    public EMAIL_ADDRESS: string = "Email address";
    public FORM_EMAIL_MANDATORY: string = 'Form email address mandatory';
    public FORM_DESCRIPTION_MANDATORY: string = 'Form description mandatory';
    public DEFAULT_LANGUAGE = this.configurationUtil.isSuprima() ? "en" :"en_US";
 	public _openFromMainMenu: boolean = false; 
    private vid: string = getVid();
   
    constructor(private mappingTablesCache: MappingTablesCache,
                private windowInfoUtils : WindowInfoUtils,
                private configurationUtil: ConfigurationUtil,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('$state') private $state: ng.ui.IStateService) {
    }

    public isReportProblem () {
        let activateWidgetRow = this.getCategoryRowFromMt(this.ACTIVATE_WIDGET);
        if (this.$state.current.name === STATE_NAMES.LEGANTO_GETIT){
            return false;
        }
        if(!(activateWidgetRow.length > 0 && isEqual(activateWidgetRow[0].target, "true"))){
            return false;
        }
        return this.getCategoryRowFromMt(this.EMAIL_ADDRESS).length > 0 && this.getCategoryRowFromMt(this.NUM_OF_CATEGORIES).length > 0;
    }

    public isFormEmailMandatory(){
        let formEmailMandatoryRow = this.getCategoryRowFromMt(this.FORM_EMAIL_MANDATORY);
        return formEmailMandatoryRow.length > 0 && isEqual(formEmailMandatoryRow[0].target, "true");
    }

    public isFormDescriptionMandatory(){
        let formDescriptionMandatoryRow = this.getCategoryRowFromMt(this.FORM_DESCRIPTION_MANDATORY);
        return formDescriptionMandatoryRow.length > 0 && isEqual(formDescriptionMandatoryRow[0].target, "true");
    }

    public sendEmail(category, address, description, captchaResponse){
        let reportPayload = this.buildReportProblemPaylod(category, address, description, captchaResponse);
        return this.$http.post(this.restBaseURLs.reportProblem, reportPayload);
    }

    public getCategoryRowFromMt(paramName){
        // Primo and Prime VE configuration
        let rowFromMt = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.REPORT_A_PROBLEM, {source1: this.vid, source2: paramName});

        // Only for Primo VE Special 'All' : all view confguration when there is not normal view configuration
        if(rowFromMt.length === 0 && this.configurationUtil.isSuprima()){
            return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.REPORT_A_PROBLEM, {source1: this.vid.split(":")[0] + ":"+ "All", source2: paramName});
        }
        return rowFromMt;
    }

    private buildReportProblemPaylod(category, address, description, captchaResponse){
        let urlWithoutBase = window.location.pathname + "?" + window.location.href.split('?')[1];

        let payload= {
            'categoryName': category,
            'vid': this.vid,
            'language': this.DEFAULT_LANGUAGE,
            'userEmailAddress': address,
            'problemDescription': description,
            'currentUrl': urlWithoutBase,
            'browserType': this.windowInfoUtils.getBrowserType(),
            'deviceType': this.windowInfoUtils.getDeviceType(),
            'captchaResponse':captchaResponse
        }
        return payload; 
    } 

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/reportProblem/reportProblem.service.ts